import sortBy from 'lodash/sortBy';

function intersect(a, b) {
  let t;
  if (b.length > a.length) {
    t = b;
    b = a;
    a = t;
  }
  return a.filter(function(e) {
    return b.indexOf(e) > -1;
  });
}

export default function pricesForZone(prices, zone) {
  let zonePrices = prices.filter(function(price) {
    return price.zones && price.zones.length > 0
      ? price.zones.indexOf(zone) !== -1
      : parseInt(price.zone_no, 10) === zone;
  });

  let rankedPriceTypes = sortBy(zonePrices, function(obj) {
    return parseInt(obj.zone_rank, 10);
  });

  let finalPriceTypes = [];

  rankedPriceTypes.forEach(priceType => {
    let priceTypeZones = priceType.zones
      ? priceType.zones
      : [priceType.zone_no];
    if (
      !finalPriceTypes.some(finalPriceType => {
        let finalPriceTypeZones = finalPriceType.zones
          ? finalPriceType.zones
          : [finalPriceType.zone_no];
        return (
          priceType.price === finalPriceType.price &&
          priceType.price_type === finalPriceType.price_type &&
          intersect(priceTypeZones, finalPriceTypeZones).length ===
            priceTypeZones.length
        );
      })
    ) {
      finalPriceTypes.push(priceType);
    }
  });

  return finalPriceTypes;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/pricing/pricesForZone.js